import HomeContent from "./homeContent.js"
export default HomeContent;